import { Helmet } from "react-helmet-async";
import PolicyModal from "../components/login/PolicyModal";
import styles from "./TermsScreen.module.css";

/**
 * @author smyun
 * @date 2025-08-04
 * @remark 서비스 이용약관 페이지 스크린
 * @param props None
 * @returns <PolicyModal>
 */
function TermsScreen() {
    return (
        <>
            <Helmet>
                <title>이용약관 - 모두의지도</title>
                <meta name="description" content="모두의지도 서비스 이용약관 안내" />
            </Helmet>
            <div>
                <div className={styles.top_div}>
                    <PolicyModal />
                </div>
            </div>
        </>
    );
}

export default TermsScreen;
